import { createTheme } from "@mui/material/styles";
import {Box} from "@mui/material";
import { ArrowDown, CheckboxChecked, CheckboxIcon } from "../assets/images/icons";
import {styled} from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: `"Manrope", "Helvetica", "Arial", sans-serif`,
    fontSize: 12.3,
  },
  breakpoints: {
    values: {
      // xs: 0,
      // sm: 360,
      // md: 768,
      // lg: 1072,
      // xl: 1248
      xs: 0,
      sm: 600, //700
      md: 930,
      lg: 1072,
      xl: 1248
    },
  },
  palette: {
    primary: {
      main: '#010D03',
      text: '#010D03',
      greyText: '#686868',
      grey: '#A9A9A9',
      greyBg: '#F8F8F8',
      greyBg2: '#ECECEC',
      lightRed: '#FFF2F2',
      lightRed2: '#FFE7E7',
      darkRed: "#BF5959",
      hoverButton: "#CC2525",
      white: "#fff",
      warning: "#D18F2C",
      green: "#2A914E",
      borderColor: "#EAEAEA",
      error: {
        main: '#D0180B',
      },
    },
    secondary: {
      main: '#E43C3C'
    }
  },
});

export const baseTheme = createTheme(theme, {
  typography: {
    h1: {
      fontSize: 40,
      fontWeight: 800,
      [theme.breakpoints.only('md')]:{
        fontSize: 32
      },
      [theme.breakpoints.only('sm')]:{
        fontSize: 26
      },
      [theme.breakpoints.only('xs')]:{
        fontSize: 22,
        lineHeight: '20px'
      }
    },
    h3: {
      fontSize: 24,
      fontWeight: 500,
      marginBottom: '19px',
      [theme.breakpoints.only('xs')]: {
        fontSize: '20px'
      },
    },
    h4: {
      fontSize: 20,
      fontWeight: 500,
    },
    h5: {
      fontSize: 16,
      fontWeight: 600,
      marginBottom: '7px'
    },
    regularCaption: {
      fontSize: 14,
      fontWeight: 400,
      color: theme.palette.primary.greyText
    },
    boldRegCaption: {
      fontSize: 14,
      fontWeight: 600,
    },
    boldLightCaption: {
      fontSize: 14,
      fontWeight: 600,
      color: theme.palette.primary.greyText,
      lineHeight: '19.6px'
    },
    timer: {
      color: theme.palette.primary.grey,
      fontSize: 16,
      fontWeight: 600
    },
    caption: {
      fontSize: 12,
      fontWeight: 500,
      lineHeight: "16.8px",
    },
    greyCaption: {
      fontSize: 12,
      fontWeight: 500,
      color: theme.palette.primary.grey,
    },
    smallCaption: {
      fontSize: 10,
      fontWeight: 800,
    },
    boldCaption: {
      fontSize: 12,
      fontWeight: 800,
    },
    formCaption: {
      borderRadius: 24,
      fontSize: 14,
      padding: "15px 25px 18px 27px",
      margin: "6px 0",
      display: "flex",
      [theme.breakpoints.only('xs')]: {
        padding: '10px 25px 10px 17px'
      },
      "&:empty": {
        display: "none",
      },
      p: {
        margin: "8px 0",
      },
      "svg": {
        width: 22,
        height: 22,
        margin: '9px 17px 0 3px',
        [theme.breakpoints.only('xs')]: {
          margin: '13px 9px 0 3px'
        },
      }
    },
    warning: {
      color: theme.palette.primary.darkRed,
      margin: "0 0 13px",
      fontSize: 12,
      fontWeight: 500
    },
    link: {
      textDecoration: 'none',
      color: theme.palette.secondary.main,
      textTransform: "uppercase",
      fontSize: 12,
      fontWeight: 800,
      cursor: 'pointer',
      ":hover": {
        color: theme.palette.primary.grey
      },
      "&.disabled": {
        color: theme.palette.primary.grey,
        cursor: 'default'
      }
    },
    linkGrey: {
      textTransform: "uppercase",
      fontSize: 12,
      fontWeight: 800,
      cursor: 'pointer',
      "> a": {
        textDecoration: 'none',
        color: theme.palette.primary.greyText,
      },
      ":hover > a": {
        color: theme.palette.secondary.main
      }
    },
    tabLink: {
      color: theme.palette.primary.grey,
      textTransform: "uppercase",
      fontSize: 12,
      fontWeight: 800,
      marginRight: '44px',
      cursor: 'pointer',
      "&.active": {
        color: theme.palette.secondary.main
      }
    },
    orderHash: {
      fontSize: 30,
      fontWeight: 200,
      letterSpacing: '0.02em',
      lineHeight: '140%',
      wordBreak: 'break-all',
      [theme.breakpoints.only('xs')]: {
        fontSize: '18px',
        fontWeight: '600'
      }
    },
    orderHashII: {
      fontSize: 40,
      fontWeight: 200,
      letterSpacing: '0.02em',
      wordBreak: 'break-all',
      [theme.breakpoints.only('xs')]: {
        fontSize: '18px',
        fontWeight: '600'
      }
    },
    orderId: {
      fontSize: 36,
      fontWeight: 200,
      letterSpacing: '0.02em',
      lineHeight: '140%',
      whiteSpace: 'nowrap',
      margin: '0px 0 7px',
      display: 'inline-block',
      [theme.breakpoints.only('md')]: {
        fontSize: 24
      },
      [theme.breakpoints.down('md')]: {
        fontSize: 32
      },
    },
    greenRate: {
      position: "absolute",
      top: "-13px",
      left: "0",
      fontSize: '10px',
      fontWeight: 800, 
      color: theme.palette.primary.green,
      whiteSpace: 'nowrap'
    },
    greenRateII: {
      fontWeight: 800, 
      color: theme.palette.primary.green,
      [theme.breakpoints.only('xs')]: {
        position: "absolute",
        top: "-13px",
        right: "0",
        fontSize: '10px',
      }
    },
    smallLabel: {
      fontSize: '10px',
      fontWeight: 800,
      textTransform: 'uppercase',
      color: theme.palette.primary.main,
      display: 'inline-block',
      margin: '0 0 8px',
    }
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          [theme.breakpoints.up('lg')]: {
            maxWidth: '1248px'
          },
          [theme.breakpoints.only('md')]: {
            paddingLeft: '40px',
            paddingRight: '40px',
          },
          [theme.breakpoints.only('xs')]: {
            paddingLeft: '10px',
            paddingRight: '10px',
          },
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          color: theme.palette.secondary.main,
          background: theme.palette.primary.lightRed2,
          border: 0,
          fontSize: 12,
          fontWeight: 800,
          "&:hover": {
            background: theme.palette.primary.hoverButton,
            color: theme.palette.primary.white,
            "@media (hover: none)": {
              color: theme.palette.secondary.main,
              background: theme.palette.primary.lightRed2
            },
          },
          "&:active": {
            background: theme.palette.secondary.main,
            "@media (hover: none)": {
              color: theme.palette.primary.white,
            },
          },
          "&:disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.12)",
            color: "rgba(0, 0, 0, 0.46)",
          },
          "&.endAdornmentButton": {
            minWidth: 185,
            letterSpacing: "0.02em",
            [theme.breakpoints.only('xs')]: {
              minWidth: 50
            },
            "&.MuiButton-Primary:hover":{
              color: theme.palette.secondary.main,
              background: '#FFD6D6'
            }, 
            "&.MuiButton-Primary:active":{
              color: theme.palette.secondary.main,
              background: theme.palette.primary.lightRed2
            }, 
            "&.MuiButton-containedPrimary:hover":{
              background: theme.palette.secondary.main,
              color: '#fff'
            }, 
          },
          "&.basicIconLeft .MuiButton-startIcon": {
            marginRight: '15px'
          },
          "&.basicIconLeft:hover .MuiButton-startIcon *": {
            fill: '#fff'
          },
          "&.containedIconLeft .MuiButton-startIcon": {
            marginRight: '15px'
          },
        },
        containedPrimary: {
          background: theme.palette.secondary.main,
          color: theme.palette.primary.white,
          "&:hover":{
            "@media (hover: none)": {
              color: theme.palette.primary.white,
              background: theme.palette.primary.hoverButton,
            }
          },
        },
        Secondary: {
          background: "#fff",
          color: theme.palette.primary.grey,
        },
        containedSecondary: {
          background: theme.palette.secondary.main,
          color: "#fff",
          "&:hover":{
            "@media (hover: none)": {
              color: theme.palette.primary.white,
              background: theme.palette.primary.hoverButton,
            }
          },
        },
        falseSecondary: {
          background: theme.palette.primary.greyBg,
          color: theme.palette.primary.grey,
        },
        sizeLarge: {
          borderRadius: 40,
          padding: "14px 32px",
          minHeight: 64,
          lineHeight: '130%',
          fontSize: 14,
        },
        sizeMedium: {
          borderRadius: 28,
          padding: "9px 20px",
        },
      },
    },
    MuiIconButton: {
      defaultProps: {
        disableFocusRipple: true,
        disableRipple: true,
      },
      styleOverrides: {
        ".arrow-button": {},
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        sizeSmall: {
          color: `${theme.palette.primary.grey} !important`,
          textTransform: "uppercase",
          left: -12,
          top: -7,
          fontWeight: 600,
          fontSize: '16px',
          letterSpacing: '0.02em',
        },
      },
    },
    MuiInput: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        root: {
          background: theme.palette.primary.greyBg,
          borderRadius: 28,
          border: 0,
          margin: "6px 0",
          fontSize: 16,
          padding: "12px 21px",
          "&.Mui-error": {
            color: theme.palette.primary.darkRed,
            ".MuiInput-input::placeholder": {
              color: theme.palette.primary.darkRed,
            },
            ".MuiInputAdornment-positionStart": {
              "svg > * ": {
                stroke: theme.palette.primary.darkRed,
              },
              "svg.phone-number > * ": {
                stroke: 'none',
                fill: theme.palette.primary.darkRed,
              },
            },
          },
        },
        adornedEnd: {
          padding: "8px 8px 8px 21px !important",
        },
        input: {
          "&::placeholder": {
            color: theme.palette.primary.grey,
            opacity: 1,
            transition: 'color 0.2s ease',
          },
          "&:hover&::placeholder": {
            color: theme.palette.primary.greyText,
          },
          "&:active&::placeholder": {
            color: theme.palette.primary.text,
          },
          "&[type=number]": {
            MozAppearance: "textfield",
          },
          "&[type=number]::-webkit-outer-spin-button": {
            WebkitAppearance: "none",
            margin: 0,
          },
          "&[type=number]::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: 0,
          },
          "&:-internal-autofill-selected": {
            WebkitBoxShadow: `0 0 0 1000px ${theme.palette.primary.greyBg} inset !important`
          },
          "&:-internal-autofill-previewed": {
            WebkitBoxShadow: `0 0 0 1000px ${theme.palette.primary.greyBg} inset !important`
          },
          "&:-internal-autofill": {
            WebkitBoxShadow: `0 0 0 1000px ${theme.palette.primary.greyBg} inset !important`
          },
          "&:-internal-autofill:hover": {
            WebkitBoxShadow: `0 0 0 1000px ${theme.palette.primary.greyBg} inset !important`
          },
          "&:-internal-autofill:focus": {
            WebkitBoxShadow: `0 0 0 1000px ${theme.palette.primary.greyBg} inset !important`
          },
          "&:-internal-autofill:active": {
            WebkitBoxShadow: `0 0 0 1000px ${theme.palette.primary.greyBg} inset !important`
          },
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          margin: "0 10px 0 0",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: 12,
          color: theme.palette.primary.grey,
          lineHeight: "15px",
          fontWeight: 600
        },
        root: {
          margin: 0,
          "&.Mui-error span": {
            color: theme.palette.secondary.main,
          },
          "&.Mui-error .MuiCheckbox-root svg > *": {
            stroke: theme.palette.secondary.main,
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          "&.Mui-error": {
            marginLeft: 19,
            marginBottom: 7,
          },
        },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        disableFocusRipple: true,
        disableRipple: true,
        icon: <CheckboxIcon />,
        checkedIcon: <CheckboxChecked />,
      },
      styleOverrides: {
        root: {
          color: theme.palette.primary.grey,
          "&:hover svg > * ": {
            stroke: `${theme.palette.secondary.main} !important`,
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: ArrowDown,
      },
      styleOverrides: {
        root: {
          margin: "6px 0",
          "&.MuiInputBase-sizeSmall": {
            ".MuiSelect-select": {
              height: 28,
              background: theme.palette.primary.greyBg2,
              fontSize: 14,
              fontWeight: 600,
              borderRadius: 8,
              padding: "5px 53px 5px 9px !important",
            },
            ".MuiSelect-icon": {
              right: 5,
              width: 17,
            },
            '[aria-expanded="true"]': {
              borderRadius: "8px 8px 0 0 !important",
              zIndex: 1301,
              ".MuiSelect-icon": {
                zIndex: 1302
              }
            },
            "&.filter": {
              color: theme.palette.secondary.main,
              ".MuiSelect-select": {
                height: 38,
                borderRadius: 28,
                background: `${theme.palette.primary.lightRed} !important`,
                padding: '0 45px 0 16px !important',
                textTransform: 'uppercase',
                fontSize: 12,
                fontWeight: 800,
                "&[aria-expanded='true']": {
                  borderRadius: '20px 20px 0 0 !important',
                  background: '#fff !important',
                  color: theme.palette.primary.text,
                  boxShadow: '0px 5px 6px -7px rgba(0, 0, 0, 0.35), 0px 4px 14px -3px rgba(0, 0, 0, 0.15)'
                },
              },
              ".MuiSelect-icon": {
                right: 15,
                "& *": {
                  stroke: 'red',
                },
                "&.MuiSelect-iconOpen *": {
                  stroke: `${theme.palette.primary.text} !important`
                }
              }
            },
            "&.Mui-disabled .MuiSelect-icon > *": {
              stroke: 'rgba(0, 0, 0, 0.38)',
            },
          },
        },
        icon: {
          right: 20,
          top: "calc(50% - 12px)",
          transition: "transform 0.2s",
        },
        select: {
          padding: "16px 20px",
          height: "auto",
          boxSizing: "border-box",
          display: "flex",
          gap: "12px",
          alignItems: "center",
          letterSpacing: "0.02em",
          background: theme.palette.primary.greyBg,
          borderRadius: 28,
          '&[aria-expanded="true"]': {
            background: "#fff",
            borderRadius: "28px 28px 0 0",
          },
          ".empty-option": {
            color: `${theme.palette.primary.grey} !important`
          }
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          borderRadius: '0 0 24px 24px !important',
          paddingTop: 0,
          "&:empty": {
            display: 'none'
          }
        },
        popper: {
          "&:before": {
            width: '100%',
            height: '4px',
            content: `" "`,
            background: '#fff',
            left: 0,
            top: '-4px',
            position: 'absolute'
          },
          "&:has(.MuiPaper-root:empty)": {
            display: 'none'
          }
        },
        root: {
          '&[aria-owns="number-listbox"] .MuiInput-root': {
            backgroundColor: '#fff',
            boxShadow: '0px 4px 14px -3px rgba(0, 0, 0, 0.15)',
            borderRadius: '24px 24px 0 0'
          },
          ".MuiInput-root": {
            padding: '12px 21px'
          }
        },
        listbox: {
          padding: '0 0 4px',
          ".MuiAutocomplete-option": {
            borderRadius: '16px',
            fontSize: '16px',
            paddingLeft: '47px',
            [theme.breakpoints.only('xs')]: {
              minHeight: '42px'
            },
            "&.Mui-focused": {
              backgroundColor: 'inherit !important',
              color: 'inherit !important',
            },
            "&[aria-selected='true']": {
              backgroundColor: 'inherit !important',
              color: 'inherit !important',
            },
            "&:hover": {
              backgroundColor: `${theme.palette.primary.lightRed} !important`,
              color: `${theme.palette.secondary.main} !important`,
            }
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.order-form": {
            ".MuiSelect-select": {
              fontSize: '16px',
            },
            "&.Mui-error .empty-option": {
              color: `${theme.palette.primary.darkRed} !important`
            }
          }
        }
      }
    },
    MuiSwitch: {
      defaultProps: {
        disableFocusRipple: true,
        disableRipple: true,
      },
      styleOverrides: {
        thumb: {
          background: theme.palette.primary.grey,
        },
        track: {
          background: "none !important",
          border: `2px solid ${theme.palette.primary.grey}`,
          opacity: "1 !important",
        },
        root: {
          ".Mui-checked": {
            ".MuiSwitch-thumb": {
              background: theme.palette.secondary.main,
            },
            " + .MuiSwitch-track": {
              border: `2px solid ${theme.palette.secondary.main}`,
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          border: 0,
        },
      },
    },
    // MuiMenu: {
    //   styleOverrides: {
    //     root: {
    //       ".MuiPaper-small": {
    //         //position: 'relative',
    //         "&:before": {
    //           width: '100%',
    //           height: '4px',
    //           content: `" "`,
    //           background: '#fff',
    //           left: 0,
    //           top: '-4px',
    //           position: 'absolute'
    //         },
    //       }
    //     }
    //   }
    // },
    MuiMenuItem: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 16,
          [theme.breakpoints.only('xs')]: {
            minHeight: 'auto'
          },
          "&.Mui-selected": {
            background: "none !important",
          },
          "&:hover": {
            background: `${theme.palette.primary.lightRed} !important`,
            color: theme.palette.secondary.main,
          },
          " > img ": {
            margin: "0 10px 0 0",
          },
          ".empty-option": {
            color: theme.palette.primary.grey,
            width: '100%',
            "&:hover": {
              color: theme.palette.secondary.main
            }
          }
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation: {
          boxShadow:
            "0px 5px 6px -7px rgba(0, 0, 0, 0.35), 0px 4px 14px -3px rgba(0, 0, 0, 0.15)",
          borderRadius: 24,
          padding: 8,
        },
        small: {
          borderRadius: "0 0 8px 8px",
          padding: 0,
          marginTop: '-1px',
          ".MuiList-root": {
            padding: 0,
            ".MuiMenuItem-root": {
              borderRadius: 0,
              fontSize: 14,
              fontWeight: 600,
              padding: "3px 4px 4px 10px",
            },
          },
          "&.filter":{
            borderRadius: '0 0 20px 20px',
            paddingBottom: 6,
            overflow: 'visible',
            transition: 'none !important',
            "&:before": {
              width: '100%',
              height: '4px',
              content: `" "`,
              background: '#fff',
              left: 0,
              top: '-4px',
              position: 'absolute'
            },
            ".MuiMenuItem-root": {
              padding: '4px 4px 6px 15px',
              fontSize: '12px',
              fontWeight: 700,
              textTransform: 'uppercase'
            },
          } 
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          "&.height-limitter": {
            maxHeight: '173px',
            overflow: 'hidden'
          }
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paperWidthLg: {
          width: 880,
          //width: 760,
          padding: "15px 8px",
        },
        paperWidthMd: {
          maxWidth: 505,
          padding: "15px 8px",
        },
        paperWidthSm: {
          maxWidth: 340,
          minWidth: 340,
          padding: "8px 0 0",
        },
        root: {
          ".link-secondary": {
            color: theme.palette.primary.grey,
            fontSize: 10,
            textTransform: "uppercase",
            fontWeight: 800,
            cursor: "pointer",
            "&:hover": {
              color: theme.palette.secondary.main,
            },
            [theme.breakpoints.only('xs')]: {
              fontSize: 10
            }
          },
          "&.userForm": {
            ".MuiDialog-paperWidthMd": {
              padding: "7px 0 0",
            },
            ".MuiDialogTitle-root": {
              paddingBottom: 10,
            },
            ".MuiButton-sizeLarge": {
              margin: "7px 0 9px",
              fontSize: 12,
              lineHeight: "16.39px",
            },
          },
          "&.updateRate": {
            ".MuiDialog-paperWidthSm": {
              maxWidth: '380px',
              minWidth: '380px',
              [theme.breakpoints.only('xs')]: {
                maxWidth: '350px',
                minWidth: '350px',
                ".MuiDialogContent-root": {
                  padding: '15px 10px 10px'
                }
              }
            },
          }
        },
        paper: {
          "&.systems-list, &.inner-scroll":{
            overflow: 'hidden',
            paddingRight: 0,
            " > .MuiBox-root": {
              overflowY: 'scroll'
            }
          },
          [theme.breakpoints.down('md')]: {
            margin: '25px 10px'
          },
        },
      },
    },
    // MuiDialogTitle: {
    //   styleOverrides: {
    //     root: {
    //       [theme.breakpoints.down('md')]: {
    //         padding: '10px 24px 20px'
    //       },
    //       [theme.breakpoints.only('xs')]: {
    //         padding: '5px 16px'
    //       }
    //     }
    //   }
    // },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          [theme.breakpoints.only('xs')]: {
            padding: '20px 15px 10px'
          }
        }
      }
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          ul: {
            justifyContent: 'center',
            margin: '40px 0 0',
            [theme.breakpoints.only('xs')]: {
              margin: '31px 0 17px'
            }
          }
        }
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        page: {
          background: 'rgba(255, 255, 255, 0.4)',
          borderRadius: '28px',
          fontSize: '14px',
          fontWeight: 600,
          color: '#fff',
          margin: '0 7px',
          //transition: 'height 0.3s ease, width 0.3s ease',
          "&:hover": {
            color: theme.palette.primary.text,
            background: 'rgba(255, 255, 255, 0.4)',
          },
          "&.Mui-selected": {
            background: '#FFFFFF !important',
            color: theme.palette.primary.text,
            width: 40,
            height: 40
          },
        },
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: '#fff',
          color: theme.palette.primary.text,
          fontSize: 12,
          padding: '24px 24px 22px 24px',
          borderRadius: '20px',
          boxShadow: '0px -2px 14px -4px rgba(0, 0, 0, 0.12), 0px 8px 14px -4px rgba(0, 0, 0, 0.16)',
          "&.tooltip-order-details": {
            maxWidth: 453,
            minWidth: 453,
            [theme.breakpoints.only('xs')]: {
              maxWidth: 'calc(100% - 20px)',
              minWidth: 'calc(100% - 20px)',
              margin: '0 10px',
            }
          },
          "&.systems-list": {
            maxWidth: 880,
            minWidth: 880,
            padding: '8px 8px',
            margin: '0 !important',
            position: 'relative',
            [theme.breakpoints.down('lg')]: {
              minWidth: '100%',
            },
            // [theme.breakpoints.only('xs')]: {
            //   borderRadius: '32px'
            // }
          }
        },
        popper: {
          // "&#systems-list": {
          //   [theme.breakpoints.only('xs')]: {
          //     transform: 'translate3d(0px, 0px, 0px) !important'
          //   }
          // },
          "&.popper-order-details": {
            [theme.breakpoints.only('xs')]: {
              position: 'fixed !important',
              top: '50% !important',
              left: '50% !important',
              transform: 'translate(-50%, -50%) !important',
              maxWidth: '100%',
              minWidth: '100%',
            }
          },
        }
      }
    },
    MuiTab: {
      defaultProps: {
        disableFocusRipple: true,
        disableRipple: true
      },
      styleOverrides: {
        root: {
          background: '#fff',
          color: theme.palette.primary.grey,
          borderRadius: '28px',
          padding:'15px 24px',
          minHeight: 'auto',
          border: 0,
          fontSize: 12,
          fontWeight: 800,
          margin: '0 4px',
          "&:first-of-type": {
            marginLeft: 0
          },
          "&:last-of-type": {
            marginRight: 0
          },
          "&:hover": {
            background: "#CC2525",
            color: theme.palette.primary.white,
          },
          '&.Mui-selected': {
            color: '#fff',
            background: theme.palette.secondary.main,
          }
        },
      }
    },
    SnackbarContainer: {
      styleOverrides: {
        bottom: {
          [theme.breakpoints.only('xs')]: {
            flexDirection: 'row'
          }
        }
      }
    },
    // MuiModal: {
    //   defaultProps: {
    //     disableScrollLock: true,
    //     disablePortal: true
    //   },
    // }
  },
});

export const ContentBox = styled(Box)(() => ({
  background: "#fff",
  boxShadow: "0px 5px 6px -7px rgba(0, 0, 0, 0.5), 0px 4px 14px -3px rgba(0, 0, 0, 0.25)",
  borderRadius: 36,
  padding: "35px 32px",
  position: "relative",
  [theme.breakpoints.down("lg")]: {
    borderRadius: "32px",
  },
  [theme.breakpoints.only("sm")]: {
    padding: "26px 30px",
  },
  [theme.breakpoints.only("xs")]: {
    padding: "26px 24px",
  },
  ".MuiTypography-h4": {
    marginBottom: 20,
  },
}));

export const MySidebar = styled(Box)(() => ({
  width: "100%",
  maxWidth: 220,
  borderLeft: `1px solid ${theme.palette.primary.borderColor}`,
  padding: "1px 0 0 40px",
  ".MuiTypography-link": {
    display: "inline-block",
    marginBottom: 18,
  },
  ".MuiTypography-4": {
    fontSize: 20,
    fontWeight: 500,
  },
}));

export const EmptyBox = styled(Box)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  textAlign: "center",
  [theme.breakpoints.only("xs")]: {
    width: 320,
  },
}));

export const PaySystemBox = styled(Box)(() => ({
  display: "flex",
  height: 56,
  background: "#F8F8F8",
  borderRadius: "28px",
  padding: "8px 25px",
  alignItems: "center",
  margin: "6px 0",
  ".MuiSelect-select": {
    background: "#F8F8F8 !important",
    "&[aria-expanded='true']": {
      background: "#fff !important",
    }
  },
}));

export const WhiteBlock = styled(Box)(() => ({
  background: "#FFFFFF",
  boxShadow:
    "0px 5px 6px -7px rgba(0, 0, 0, 0.5), 0px 4px 14px -3px rgba(0, 0, 0, 0.25)",
  borderRadius: "32px",
  width: "100%",
  padding: "40px",
}));